export default "__VITE_ASSET__OddUxUGl__"